import { render, staticRenderFns } from "./vLoader.vue?vue&type=template&id=11488b75"
import script from "./vLoader.vue?vue&type=script&lang=js"
export * from "./vLoader.vue?vue&type=script&lang=js"
import style0 from "./vLoader.vue?vue&type=style&index=0&id=11488b75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports